module.exports = __webpack_public_path__ + "static/media/sb.40725ee9.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/sb.svg
// module id = 937
// module chunks = 0